import { useState, useEffect, useCallback } from "react";
import { api } from "../api/client";

export const useFetch = (fetcher, deps = []) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetch_ = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const result = await fetcher();
      setData(result);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, deps); // eslint-disable-line

  useEffect(() => { fetch_(); }, [fetch_]);

  return { data, loading, error, refetch: fetch_ };
};

export const useJobs = (params) =>
  useFetch(() => api.jobs.list(params), [JSON.stringify(params)]);

export const useAdminDashboard = () =>
  useFetch(() => api.admin.dashboard(), []);

export const useAdminUsers = (role) =>
  useFetch(() => api.admin.users(role), [role]);

export const useAdminJobs = (status) =>
  useFetch(() => api.admin.allJobs(status), [status]);

export const usePriceTable = () =>
  useFetch(() => api.priceTable.list(), []);

export const useAdminPriceTable = () =>
  useFetch(() => api.priceTable.adminList(), []);

export const useMyWithdrawals = () =>
  useFetch(() => api.withdrawals.myList(), []);

export const useAdminWithdrawals = () =>
  useFetch(() => api.withdrawals.adminList(), []);

export const useMyDocuments = () =>
  useFetch(() => api.documents.myList(), []);

export const useAction = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  const run = async (fn) => {
    setLoading(true);
    setError(null);
    setSuccess(null);
    try {
      const result = await fn();
      setSuccess(result);
      return result;
    } catch (err) {
      setError(err.message);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const clear = () => { setError(null); setSuccess(null); };

  return { loading, error, success, run, clear };
};
